import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Button,
  Container,
  Divider,
  FormControl,
  Radio,
  RadioGroup,
  Typography,
  CircularProgress,
  Alert,
  useMediaQuery,
  Chip,
  Checkbox,
  FormControlLabel,
  FormGroup,
  TextField,
  InputAdornment,
  Modal,
  Backdrop,
  LinearProgress,
} from "@mui/material";
import { Close as CloseIcon, SquareFoot } from "@mui/icons-material";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Loader } from "@googlemaps/js-api-loader";
import { useTheme } from "@mui/material/styles";
import { useNavigate, useParams } from "react-router-dom";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import { StylesConfig } from "react-select";
import placesApiKey from "../../components/utils/Google-Places-API-Key";
import dayjs from "dayjs";
import {
  createMoveService,
  getMoveService,
} from "../../redux/action/move-service";
import { unwrapResult } from "@reduxjs/toolkit";
import { useDispatch } from "react-redux";
import { getCarrierByBusinessName } from "../../redux/action/carrier";
import { createLabourAndPacking } from "../../redux/action/labour-and-packing";
import { Message, Phone } from "@mui/icons-material";
import Header from "../header/Header";
import axios from "axios";
const PLACES_API_KEY = placesApiKey;

interface AddressOption {
  label: string;
  value: any;
}

interface ChooseServiceProps {
  serviceType: "move-service" | "labour-and-packing";
}
const mapsLoader = new Loader({
  apiKey: PLACES_API_KEY,
  version: "weekly",
  libraries: ["places", "geometry"],
});
const autocompleteStyles: StylesConfig<AddressOption, false> = {
  input: (provided) => ({
    ...provided,
    color: "#000000",
    height: "100%",
    borderRadius: "8px",
  }),
  option: (provided) => ({
    ...provided,
    color: "#808080",
  }),
  singleValue: (provided) => ({
    ...provided,
    color: "#808080",
  }),
};
const ChooseService: React.FC<ChooseServiceProps> = ({ serviceType }) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [selectedService, setSelectedService] = useState("");
  const [fromAddress, setFromAddress] = useState<AddressOption | null>(null);
  const [toAddress, setToAddress] = useState<AddressOption | null>(null);
  const [movingDate, setMovingDate] = useState<any>(null);
  const [bedroomCount, setBedroomCount] = useState("");
  const [isBedroomOpen, setIsBedroomOpen] = useState(false);
  const [distance, setDistance] = useState<number | null>(null);
  const [isCalculating, setIsCalculating] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [mapsLoaded, setMapsLoaded] = useState(false);
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [propertyType, setPropertyType] = useState<
    "home" | "apartment" | "storage" | ""
  >("");
  const { businessName, carrierCanonicalId } = useParams();
  const [carrier, setCarrier] = useState<any>(null);
  const containerRef = useRef<HTMLDivElement>(null);
  const lastStep = 1;
  const canonicalId = localStorage.getItem("canonicalId");

  const [carrierLocations, setCarrierLocations] = useState<any>([]);
  const [locationExists, setLocationExists] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState("");
  const [squareFootageModalOpen, setSquareFootageModalOpen] = useState(false);
  useEffect(() => {
    if (businessName) {
      dispatch<any>(getCarrierByBusinessName(businessName))
        .then(unwrapResult)
        .then((res: any) => {
          setCarrier(res);
          setCarrierLocations(res.locations);
          console.log(res.locations, "LOCATIONS");
        })
        .catch((err: any) => {
          console.error("Failed to fetch carrier data:", err);
        });
    }
  }, [businessName, dispatch]);
  useEffect(() => {
    if (canonicalId) {
      dispatch<any>(getMoveService(canonicalId))
        .then(unwrapResult)
        .then((res: any) => {})
        .catch((err: any) => {
          console.error("Failed to fetch move data:", err);
        });
    }
  }, [canonicalId]);

  useEffect(() => {
    const loadMaps = async () => {
      try {
        await mapsLoader.load();
        setMapsLoaded(true);
      } catch (err) {
        console.error("Error loading Google Maps API:", err);
        setError("Failed to load maps service. Please refresh the page.");
      }
    };

    loadMaps();
  }, []);

  const formatDateTime = (date: any): string => {
    if (!date || !dayjs(date).isValid()) {
      return dayjs().format("YYYY-MM-DD");
    }
    return dayjs(date).format("YYYY-MM-DD");
  };

  const generateMoveOrderNumber = (): string => {
    const letters = Array.from({ length: 2 }, () =>
      String.fromCharCode(65 + Math.floor(Math.random() * 26))
    ).join("");
    const digits = Math.floor(100000 + Math.random() * 900000);
    return `${letters}${digits}`;
  };

  const getDefaultSquareFeet = () => {
    if (propertyType === "home") {
      if (bedroomCount === "Studio") {
        return 657;
      } else if (bedroomCount === "1 Bedroom") {
        return 791;
      } else if (bedroomCount === "2 Bedroom") {
        return 1274;
      } else if (bedroomCount === "3 Bedroom") {
        return 1917;
      } else if (bedroomCount === "4 Bedroom") {
        return 2658;
      } else if (bedroomCount === "5+ Bedroom") {
        return 3514;
      }
    } else if (propertyType === "apartment") {
      if (bedroomCount === "Studio") {
        return 457;
      } else if (bedroomCount === "1 Bedroom") {
        return 735;
      } else if (bedroomCount === "2 Bedroom") {
        return 1097;
      } else if (bedroomCount === "3 Bedroom") {
        return 1336;
      } else if (bedroomCount === "4 Bedroom") {
        return 1800;
      } else if (bedroomCount === "5+ Bedroom") {
        return 3000;
      }
    } else if (propertyType === "storage") {
      return 0;
    }
    return 0;
  };

  const handleNext = async () => {
    if (
      !fromAddress ||
      !toAddress ||
      !movingDate ||
      !bedroomCount ||
      !propertyType
    ) {
      setError("Please fill in all required fields");
      return;
    }
    setIsLoading(true);
    setLoadingMessage("Processing your move request...");
    const formattedDateTime = formatDateTime(movingDate);

    const serviceData = {
      moving_from: fromAddress.label,
      moving_to: toAddress.label,
      moving_date: formattedDateTime,
      number_of_bedrooms: bedroomCount,
      move_order_number: generateMoveOrderNumber(),
      dwelling_type: propertyType,
      carrier_id: carrier?.id,
      phone_number: phoneNumber,
      last_step: lastStep,
      pickup_square_footage:
        squareFootage !== null ? Number(squareFootage) : getDefaultSquareFeet(),
    };
    console.log(serviceData, "PAYLOAD ----->>>>");

    try {
      let res;
      if (serviceType === "move-service") {
        res = await dispatch<any>(createMoveService(serviceData));
        const newRes = unwrapResult(res);
        const newCanonicalId = newRes.canonical_id;
        localStorage.setItem("canonicalId", newCanonicalId);

        const moveService = await dispatch<any>(getMoveService(newCanonicalId));
        const unwrappedMove = unwrapResult(moveService);
        setDistance(unwrappedMove.distance);
      } else {
        res = await dispatch<any>(createLabourAndPacking(serviceData));
      }

      const result = unwrapResult(res);
      const newCanonicalId = result.canonical_id;
      if (propertyType === "home") {
        navigate(
          `/${businessName}/${carrierCanonicalId}/delivery-details/${newCanonicalId}`
        );
      } else if (propertyType === "apartment") {
        navigate(
          `/${businessName}/${carrierCanonicalId}/apartment-info/${newCanonicalId}`
        );
      } else if (propertyType === "storage") {
        navigate(
          `/${businessName}/${carrierCanonicalId}/storage/${newCanonicalId}`
        );
      }
    } catch (err: any) {
      setError(err?.message || "Failed to create service");
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    if (fromAddress !== null) {
      checkIfLocationExists();
    } else {
      setSquareFootage(null);
      setApiError(null);
    }
  }, [fromAddress]);

  const handleFromAddressChange = (value: AddressOption | null) => {
    setFromAddress(value);
    setSquareFootage(null);
    setApiError(null);
  };

  const handleToAddressChange = (value: AddressOption | null) => {
    setToAddress(value);
  };

  const handleBedroomChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    value: string
  ) => {
    setBedroomCount(value);
    setIsBedroomOpen(false);
    setSelectedService("");
  };

  const toggleBedroomDropdown = () => {
    setIsBedroomOpen((prev) => !prev);
    setSelectedService("bedrooms");
  };

  const handlePropertyTypeChange = (type: "home" | "apartment" | "storage") => {
    setPropertyType(type);
  };

  const handleBack = () => {
    navigate(`/${businessName}/select-service`);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target as Node)
      ) {
        setSelectedService("");
        setIsBedroomOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const isStateInLocations = (address: any, locations: any) => {
    const stateFromAddress = address
      .split(",")
      [address.split(",").length - 2].trim();

    return locations.some((location: any) =>
      location.location_name.includes(stateFromAddress)
    );
  };
  const checkIfLocationExists = () => {
    const exists = isStateInLocations(fromAddress?.label, carrierLocations);
    if (exists === true) {
      setLocationExists(true);
      if (fromAddress) {
        fetchSquareFootage(fromAddress.label);
      }
    } else {
      setLocationExists(false);
    }
  };
  useEffect(() => {
    if (fromAddress !== null) {
      checkIfLocationExists();
    }
  }, [fromAddress]);

  const [squareFootage, setSquareFootage] = useState<number | null>(null);
  const [isFetchingSquareFootage, setIsFetchingSquareFootage] = useState(false);
  const [apiError, setApiError] = useState<string | null>(null);
  const fetchZipCodeForAddress = async (address: string) => {
    const apiKey = "AIzaSyAk8hBHGztX6M9UX2MdZlRQS3HbdqINzp8";
    const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
      address
    )}&key=${apiKey}`;

    try {
      const response = await axios.get(url);
      const results = response.data.results;
      const zipCode = results[0].address_components?.find((component: any) =>
        component.types.includes("postal_code")
      )?.long_name;
      return zipCode ? zipCode.toString() : "";
    } catch (error) {
      console.error("Error fetching ZIP code:", error);
      throw error;
    }
  };
  const formatAddressForAttom = async (address: string) => {
    const zip = await fetchZipCodeForAddress(address);
    const formattedAddress = `${address
      .replace(/,/g, "")
      .replace(/\s+/g, "+")}+${zip}`;
    return formattedAddress;
  };

  const fetchSquareFootage = async (
    address: string
  ): Promise<number | null> => {
    try {
      setIsFetchingSquareFootage(true);
      setApiError(null);
      const formattedAddress = await formatAddressForAttom(address);
      console.log(formattedAddress, "formattedAddress");
      const url = `https://api.gateway.attomdata.com/propertyapi/v1.0.0/property/detail?address=${formattedAddress}`;

      const response = await axios.get(url, {
        headers: {
          Accept: "application/json",
          apikey: "d8d89aa9312597abe96c9f8d0afaa9f8",
        },
      });

      const data = response.data;

      if (!data || !data.property || !data.property[0]) {
        setApiError("No property data found for this address");
        return null;
      }

      const property = data.property[0].building;
      if (property.size && property.size.livingsize) {
        const squareFootage = property.size.livingsize;
        if (squareFootage > 3400) {
          setSquareFootageModalOpen(true);
        }
        setSquareFootage(squareFootage);
        return squareFootage;
      }

      setApiError("Square footage information not available for this property");
      return null;
    } catch (error: any) {
      console.error("Error fetching property details:", error);
      // setApiError("Error fetching property details");
      return null;
    } finally {
      setIsFetchingSquareFootage(false);
    }
  };
  return (
    <div ref={containerRef}>
      <Header />
      {isLoading && (
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={isLoading}
          onClick={() => {
            setIsLoading(true);
          }}
        >
          <Box sx={{ width: "50%" }}>
            <LinearProgress />
            <Typography
              fontSize={16}
              fontWeight={500}
              textAlign="center"
              mt={1}
            >
              {loadingMessage}
            </Typography>
          </Box>
        </Backdrop>
      )}
      <Container
        sx={{
          width: "100%",
          maxWidth: "100%",
          height: isMobile ? "93vh" : "80vh",
          boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
          padding: isMobile ? "20px" : "20px",
          background: "#f2f0f0",
          margin: "0 auto",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          overflowY: "auto",
        }}
      >
        {squareFootageModalOpen && (
          <Modal
            open={squareFootageModalOpen}
            onClose={() => {
              setSquareFootageModalOpen(false);
              setFromAddress(null);
            }}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              borderColor: theme.palette.primary.main,
            }}
          >
            <Box
              sx={{
                backgroundColor: "#FFFFFF",
                padding: 3,
                borderRadius: "8px",
                maxWidth: "80%",
                width: "auto",
                boxShadow: 3,
                transition: "transform 0.3s ease-out",
                transform: squareFootageModalOpen ? "scale(1)" : "scale(0.5)",
                borderColor: theme.palette.primary.main,
              }}
            >
              <Button
                onClick={() => {
                  setSquareFootageModalOpen(false);
                  setFromAddress(null);
                }}
                sx={{
                  position: "absolute",
                  top: 10,
                  right: 10,
                  backgroundColor: "transparent",
                  border: "none",
                  cursor: "pointer",
                  "&:hover": { backgroundColor: "#f0f0f0" },
                }}
              >
                <CloseIcon />
              </Button>

              <Typography
                fontSize={14}
                sx={{ marginBottom: 2, fontWeight: "bold" }}
              >
                SQUARE FOOTAGE EXCEEDS STANDARD SIZE
              </Typography>
              <Typography variant="body1" sx={{ marginBottom: 3 }}>
                Your square footage exceeds our standard size limit. Please
                contact your carrier at +1 {carrier?.business_phone} for further
                assistance.
              </Typography>
              <Button
                variant="contained"
                color="primary"
                fullWidth
                sx={{
                  fontWeight: "bold",
                  textTransform: "none",
                  padding: "10px",
                  borderRadius: "20px",
                  "&:hover": { backgroundColor: "#357ABD" },
                }}
                onClick={() => {
                  setSquareFootageModalOpen(false);
                  setFromAddress(null);
                }}
              >
                Close
              </Button>
            </Box>
          </Modal>
        )}
        {locationExists === false ? (
          <Modal
            open={!locationExists}
            onClose={() => {
              setLocationExists(null);
              setFromAddress(null);
            }}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              borderColor: theme.palette.primary.main,
            }}
          >
            <Box
              sx={{
                backgroundColor: "#FFFFFF",
                padding: 3,
                borderRadius: "8px",
                maxWidth: "80%",
                width: "auto",
                boxShadow: 3,
                transition: "transform 0.3s ease-out",
                transform: !locationExists ? "scale(1)" : "scale(0.5)",
                borderColor: theme.palette.primary.main,
              }}
            >
              <Button
                onClick={() => {
                  setLocationExists(null);
                  setFromAddress(null);
                }}
                sx={{
                  position: "absolute",
                  top: 10,
                  right: 10,
                  backgroundColor: "transparent",
                  border: "none",
                  cursor: "pointer",
                  "&:hover": { backgroundColor: "#f0f0f0" },
                }}
              >
                <CloseIcon />
              </Button>

              <Typography
                fontSize={14}
                sx={{ marginBottom: 2, fontWeight: "bold" }}
              >
                YOUR CARRIER DOES NOT OPERATE IN THIS LOCATION.
              </Typography>
              <Typography variant="body1" sx={{ marginBottom: 3 }}>
                Please contact your carrier at +1{" "}
                {carrier?.customer_service_phone} for further assistance.
              </Typography>
              <Button
                variant="contained"
                color="primary"
                fullWidth
                sx={{
                  fontWeight: "bold",
                  textTransform: "none",
                  padding: "10px",
                  borderRadius: "20px",
                  "&:hover": { backgroundColor: "#357ABD" },
                }}
                onClick={() => {
                  setLocationExists(null);
                  setFromAddress(null);
                }}
              >
                Close
              </Button>
            </Box>
          </Modal>
        ) : null}
        <Box>
          <Typography
            fontWeight={700}
            fontSize={isMobile ? "16px" : "18px"}
            textAlign="center"
            mb={2}
          >
            Please choose which service you would like:
          </Typography>
          <Divider sx={{ background: "#D3D3D3" }} />

          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}

          {distance !== null && serviceType === "move-service" && (
            <Alert
              severity={distance > 200 ? "info" : "success"}
              sx={{ mb: 2 }}
            >
              {distance > 200 ? (
                <>
                  Long distance move: ~{Math.round(distance)} miles (special
                  documentation required)
                </>
              ) : (
                <>Local move: ~{Math.round(distance)} miles</>
              )}
            </Alert>
          )}

          <Box sx={{ mt: 2 }}>
            {[
              {
                label: "Moving from location",
                value: "movingFrom",
                icon: (
                  <LocationOnIcon sx={{ color: theme.palette.primary.main }} />
                ),
                selectedValue: fromAddress?.label,
              },
              {
                label: "Moving to location",
                value: "movingTo",
                icon: (
                  <LocationOnIcon sx={{ color: theme.palette.primary.main }} />
                ),
                selectedValue: toAddress?.label,
              },
              {
                label: "Moving date",
                value: "movingDate",
                icon: (
                  <CalendarTodayIcon
                    sx={{ color: theme.palette.primary.main }}
                  />
                ),
                selectedValue:
                  movingDate && movingDate.isValid()
                    ? movingDate.format("MM/DD/YYYY")
                    : null,
              },
              {
                label: "Number of bedrooms",
                value: "bedrooms",
                icon: (
                  <ExpandMoreIcon
                    sx={{
                      color: theme.palette.primary.main,
                      transform: isBedroomOpen
                        ? "rotate(180deg)"
                        : "rotate(0deg)",
                      transition: "transform 0.3s ease",
                    }}
                  />
                ),
                selectedValue: bedroomCount,
              },
              {
                label: "Phone Number",
                value: "phoneNumber",
                icon: <Phone sx={{ color: theme.palette.primary.main }} />,
                selectedValue: phoneNumber,
              },
            ].map((option) => (
              <Box key={option.value}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: "12px",
                    mb: 1,
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    if (option.value === "bedrooms") {
                      toggleBedroomDropdown();
                    } else {
                      setSelectedService(option.value);
                    }
                  }}
                >
                  <Box sx={{ display: "flex", flexDirection: "column" }}>
                    <Typography fontSize={16} sx={{ textAlign: "left" }}>
                      {option.label}
                    </Typography>
                    {option.selectedValue && (
                      <Chip
                        label={option.selectedValue}
                        size="small"
                        sx={{
                          mt: 0.5,
                          backgroundColor: "#e0e0e0",
                          maxWidth: "100%",
                          textOverflow: "ellipsis",
                          overflow: "hidden",
                        }}
                      />
                    )}
                  </Box>
                  {option.icon}
                </Box>

                {selectedService === option.value && (
                  <>
                    {option.value === "movingFrom" && (
                      <Box sx={{ mt: 2 }}>
                        <GooglePlacesAutocomplete
                          apiOptions={{ language: "en" }}
                          minLengthAutocomplete={1}
                          debounce={1000}
                          selectProps={{
                            styles: autocompleteStyles,
                            onChange: handleFromAddressChange,
                            placeholder:
                              "Enter Full Address (e.g., 123 Main St, City, State ZIP)",
                            value: fromAddress,
                          }}
                        />
                        {/* {isFetchingSquareFootage && (
                          <Typography
                            variant="body2"
                            sx={{ mt: 1, color: "text.secondary" }}
                          >
                            Fetching property details...
                          </Typography>
                        )} */}
                        {/* {apiError && (
                          <Alert severity="warning" sx={{ mt: 1 }}>
                            {apiError.includes("Address error") ? (
                              <>
                                <strong>Address Error:</strong> Please enter a
                                complete and detailed address including:
                                <ul
                                  style={{
                                    marginTop: "4px",
                                    marginBottom: "4px",
                                    paddingLeft: "20px",
                                  }}
                                >
                                  <li>Street number and name</li>
                                  <li>City</li>
                                  <li>State</li>
                                  <li>ZIP code (if available)</li>
                                </ul>
                                Example:{" "}
                                <strong>
                                  "104 Meir Ln College Station, TX 77845"
                                </strong>
                              </>
                            ) : (
                              apiError
                            )}
                          </Alert>
                        )} */}
                        {/* {squareFootage &&
                          !isFetchingSquareFootage &&
                          !apiError && (
                            <Box
                              sx={{
                                mt: 2,
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                                backgroundColor: theme.palette.grey[100],
                                borderRadius: 1,
                                p: 1.5,
                                borderLeft: `4px solid ${theme.palette.primary.main}`,
                              }}
                            >
                              <SquareFoot color="primary" fontSize="small" />
                              <Typography
                                variant="body2"
                                sx={{
                                  color: theme.palette.text.secondary,
                                  fontWeight: 500,
                                  "& strong": {
                                    color: theme.palette.text.primary,
                                    fontWeight: 600,
                                  },
                                }}
                              >
                                Estimated:{" "}
                                <strong>{squareFootage} sq. ft.</strong>
                              </Typography>
                            </Box>
                          )} */}
                      </Box>
                    )}

                    {option.value === "movingTo" && (
                      <Box sx={{ mt: 2 }}>
                        <GooglePlacesAutocomplete
                          apiOptions={{ language: "en" }}
                          minLengthAutocomplete={1}
                          debounce={1000}
                          selectProps={{
                            styles: autocompleteStyles,
                            onChange: handleToAddressChange,
                            placeholder: "Enter Address",
                            value: toAddress,
                          }}
                        />
                      </Box>
                    )}

                    {option.value === "movingDate" && (
                      <Box sx={{ mt: 2 }}>
                        <TextField
                          fullWidth
                          type="date"
                          value={
                            movingDate ? movingDate.format("YYYY-MM-DD") : ""
                          }
                          onChange={(e) => {
                            const selectedDate = dayjs(e.target.value);
                            if (selectedDate.isValid()) {
                              setMovingDate(selectedDate);
                            }
                          }}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          inputProps={{
                            min: dayjs().add(2, "day").format("YYYY-MM-DD"), // Set minimum date to the day after tomorrow (disables today and tomorrow)
                          }}
                          sx={{
                            backgroundColor: "#fff",
                            borderRadius: "8px",
                            "& .MuiOutlinedInput-root": {
                              borderRadius: "8px",
                            },
                          }}
                        />
                      </Box>
                    )}

                    {option.value === "bedrooms" && isBedroomOpen && (
                      <FormControl
                        component="fieldset"
                        sx={{ mt: 2, width: "100%" }}
                      >
                        <Box
                          sx={{
                            maxHeight: "250px",
                            overflowY: "auto",
                            borderRadius: "4px",
                            paddingLeft: "12px",
                          }}
                        >
                          <RadioGroup
                            aria-label="bedrooms"
                            value={bedroomCount}
                            onChange={handleBedroomChange}
                          >
                            {[
                              "Studio",
                              "1 Bedroom",
                              "2 Bedroom",
                              "3 Bedroom",
                              "4 Bedroom",
                              "5+ Bedroom",
                            ].map((bedroomOption) => (
                              <Box
                                key={bedroomOption}
                                sx={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  padding: "8px 0",
                                }}
                              >
                                <Typography
                                  fontSize={16}
                                  sx={{ textAlign: "left" }}
                                >
                                  {bedroomOption}
                                </Typography>
                                <Radio
                                  sx={{ color: theme.palette.primary.main }}
                                  value={bedroomOption}
                                  checked={bedroomCount === bedroomOption}
                                  onChange={(e) =>
                                    handleBedroomChange(e, bedroomOption)
                                  }
                                />
                              </Box>
                            ))}
                          </RadioGroup>
                        </Box>
                      </FormControl>
                    )}
                    {option.value === "phoneNumber" && (
                      <Box sx={{ mt: 2 }}>
                        <TextField
                          fullWidth
                          label="Phone Number"
                          value={phoneNumber}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (/^\d*$/.test(value) && value.length <= 10) {
                              setPhoneNumber(value);
                            }
                          }}
                          error={
                            phoneNumber.length > 0 && phoneNumber.length !== 10
                          }
                          helperText={
                            phoneNumber.length > 0 && phoneNumber.length !== 10
                              ? "Please enter a valid 10-digit phone number"
                              : ""
                          }
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <Message
                                  sx={{
                                    mr: 1,
                                    color: theme.palette.primary.main,
                                  }}
                                />{" "}
                                +1
                              </InputAdornment>
                            ),
                          }}
                          placeholder="Enter phone number"
                          sx={{
                            backgroundColor: "#fff",
                            borderRadius: "8px",
                            "& .MuiOutlinedInput-root": {
                              borderRadius: "8px",
                            },
                          }}
                        />
                      </Box>
                    )}
                  </>
                )}
              </Box>
            ))}
            <Box sx={{ mt: 2, mb: 2 }}>
              <Typography fontWeight={600} mb={1}>
                Pickup Details
              </Typography>
              <FormGroup row>
                {[
                  { label: "Home", value: "home" },
                  { label: "Apartment", value: "apartment" },
                  { label: "Storage", value: "storage" },
                ].map((type) => (
                  <FormControlLabel
                    key={type.value}
                    control={
                      <Checkbox
                        checked={propertyType === type.value}
                        onChange={() =>
                          handlePropertyTypeChange(
                            type.value as "home" | "apartment" | "storage"
                          )
                        }
                        color="primary"
                      />
                    }
                    label={type.label}
                  />
                ))}
              </FormGroup>
            </Box>
          </Box>
        </Box>

        <Box
          sx={{
            display: "flex",
            width: "100%",
            alignItems: "center",
            justifyContent: "space-between",
            paddingBottom: "20px",
            marginTop: "20px",
          }}
        >
          <Button
            variant="outlined"
            sx={{
              borderRadius: "20px",
              borderColor: theme.palette.primary.main,
              color: theme.palette.primary.main,
              padding: isMobile ? "8px 20px" : "8px 45px",
              textTransform: "none",
              fontSize: isMobile ? "12px" : "14px",
              fontWeight: "600",
            }}
            onClick={handleBack}
          >
            Back
          </Button>
          <Button
            variant="contained"
            sx={{
              borderRadius: "20px",
              backgroundColor: theme.palette.primary.main,
              color: "#fff",
              padding: isMobile ? "8px 20px" : "8px 45px",
              textTransform: "none",
              fontSize: isMobile ? "12px" : "14px",
              fontWeight: "600",
              "&:hover": { backgroundColor: "#357ABD" },
              "&:disabled": {
                backgroundColor: "#cccccc",
                color: "#666666",
              },
            }}
            onClick={handleNext}
            disabled={
              !fromAddress ||
              !toAddress ||
              !movingDate ||
              !bedroomCount ||
              !propertyType ||
              isCalculating
            }
          >
            {isCalculating ? (
              <CircularProgress size={24} color="inherit" />
            ) : (
              "Continue"
            )}
          </Button>
        </Box>
      </Container>
    </div>
  );
};

export default ChooseService;
